export const ERC20_APPROVE_ABI = [
  {
    inputs: [
      { name: 'spender', type: 'address' },
      { name: 'value', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
] as const;

const ETHEREUM_CHAIN_ID = 1;
const ETHEREUM_USDT_ADDRESS = '0xdac17f958d2ee523a2206206994597c13d831ec7';

interface RequiresAllowanceResetParams {
  chainId: number;
  tokenAddress: string;
  currentAllowance: string | bigint;
  nextAllowance: string | bigint;
}

export const requiresAllowanceReset = ({
  chainId,
  tokenAddress,
  currentAllowance,
  nextAllowance,
}: RequiresAllowanceResetParams): boolean =>
  chainId === ETHEREUM_CHAIN_ID &&
  tokenAddress.toLowerCase() === ETHEREUM_USDT_ADDRESS &&
  BigInt(currentAllowance) > BigInt(0) &&
  BigInt(nextAllowance) > BigInt(0);
